// Maximum number of individual Damage positions drawn for one Defect Pattern.
export const MAX_BLADE_CARD_POSITIONS = 300;
